import { AxiosInstance } from '../services/auth/AxiosInstance';

// Fetch all chats for the current user
export const getUserChats = async () => {
    try {
        const response = await AxiosInstance.get('/chats');
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Fetch a specific chat by ID
export const getChatById = async (chatId) => {
    try {
        const response = await AxiosInstance.get(`/chats/${chatId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Create a new direct chat
export const createDirectChat = async (recipientId) => {
    try {
        const response = await AxiosInstance.post('/chats/direct', { recipientId });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Delete a chat (only direct chats)
export const deleteChat = async (chatId) => {
    try {
        const response = await AxiosInstance.delete(`/chats/${chatId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
// Initiate a call (sends email invitations)
export const initiateCall = async (chatId, callData) => {
    try {
        const response = await AxiosInstance.post(`/chats/${chatId}/call`, callData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Add participant to an order chat
export const addParticipantToChat = async (chatId, userIdToAdd) => {
    try {
        const response = await AxiosInstance.patch(`/chats/${chatId}/participants/add`, { userIdToAdd });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Remove participant from an order chat
export const removeParticipantFromChat = async (chatId, userIdToRemove) => {
    try {
        const response = await AxiosInstance.patch(`/chats/${chatId}/participants/remove`, { userIdToRemove });
        return response.data;
    } catch (error) {
        throw error;
    }
};
